
import { useUiStore, useStorageStore, useLoginStore } from "@/store";
import helper from "@/shared/utills/helper";
import { dateTime } from "@/shared/utills/date";
import vuetify from "@/plugins/vuetify";

export default function registerUiActions(app) {
  const { globalProperties } = app.config;

  const uiStore = useUiStore();
  const storageStore = useStorageStore();
  const loginStore = useLoginStore();

  Object.assign(globalProperties, {
    // Loading
    $startLoading: uiStore.startLoading,
    $stopLoading: uiStore.stopLoading,
    $startGlobalLoading: uiStore.startGlobalLoading,
    $stopGlobalLoading: uiStore.stopGlobalLoading,

    // Notifications & Dialogs
    $showNotification: uiStore.showNotification,
    $showDialog: uiStore.openMidDialog,
    $closeDialog: uiStore.closeMidDialog,
    $showConfirmPopup: uiStore.showConfirm,

    // Storage & Helpers
    $localStorage: storageStore,
    $helper: helper,
    $dateTime: dateTime,

    // Validation
    $getFieldError: (field) =>
      field?.$invalid && field?.$dirty,

    $getFieldMessages: (field) =>
      field?.$errors?.map(({ $message }) => $message) || [],
  });

  // Reactive global properties
  Object.defineProperties(globalProperties, {
    $auth: {
      configurable: true,
      get: () => loginStore.loginDetails,
    },

    $isDark: {
      configurable: true,
      get: () => vuetify.theme.global.current.value.dark,
    },
  });
}
